import { createContext, useContext, useState } from "react"

const Context = createContext(null)

export function MoonphaseCalendarProvider({ children }) {
  const [hemisphere, setHemisphere] = useState("north")
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  const openCalendar = () => setIsCalendarOpen(true)
  const closeCalendar = () => setIsCalendarOpen(false)

  return (
    <Context.Provider value={{ closeCalendar, hemisphere, isCalendarOpen, openCalendar, setHemisphere }}>
      {children}
    </Context.Provider>
  )
}

export function useMoonphaseCalendar() {
  const context = useContext(Context)

  if (!context) throw new Error("useMoonphaseCalendar must be used within MoonphaseCalendarProvider")

  return context
}
